export const CLOUDFLARE_GRAY = "#404041";
export const CLOUDFLARE_ORANGE = "#F48120";
